/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SysParamDto } from '../../models/sys-param-dto';

export interface UpdateSysParam$Params {
  id: string;
      body: SysParamDto
}

export function updateSysParam(http: HttpClient, rootUrl: string, params: UpdateSysParam$Params, context?: HttpContext): Observable<StrictHttpResponse<SysParamDto>> {
  const rb = new RequestBuilder(rootUrl, updateSysParam.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SysParamDto>;
    })
  );
}

updateSysParam.PATH = '/v1/sysparams/{id}';
